import { updateTabsPosition } from './update-tabs-position';

const CSS_PREFIX = 'ftbl__';
const TAB_ITEM_CLASS_PREFIX = 'tab-item--';
const ACTIVE_TAB_CLASS_PREFIX = 'active-tab--';
const TAB_SWITCH_CONTENT_ID = 'tabs-switch__content-';
const TAB_SWITCH_CONTENT = 'tabs-switch__content';
const TABS_MENU_CLASSNAME = 'tabs-menu--dark';

export const urlUpdate = (url: string, history: History | any): void => {
  console.log('hydrate-tabs-menu urlUpdate', { url, history });
  history.pushState({}, '', url);
};

/* Events*/
const LIVE_SCORE_MENU_ITEM_CLICKED_EVENT = 'live_score_menu_item_clicked';

export const getActiveTab = (tabOrContent: 'TAB' | 'CONTENT'): HTMLElement | null => {
  const tabsMenuElement: Element | null = document.querySelector(`.${CSS_PREFIX}${TABS_MENU_CLASSNAME}`);
  console.log('hydrate-tabs-menu getActiveTab', { tabsMenuElement });

  if (tabsMenuElement) {
    // CURRENT TAB
    const activeTabAttribute: string = tabsMenuElement.getAttribute('data-state') ?? '';
    console.log('hydrate-tabs-menu getActiveTab', { activeTabAttribute });

    // From "active-tab--3" to "tab-item--3"
    const activeTab: string = activeTabAttribute.replace(
      ACTIVE_TAB_CLASS_PREFIX,
      tabOrContent === 'TAB' ? TAB_ITEM_CLASS_PREFIX : TAB_SWITCH_CONTENT_ID
    );

    console.log('hydrate-tabs-menu getActiveTab', { activeTab });

    const activeTabElement: HTMLElement | null = document.querySelector(`#${CSS_PREFIX}${activeTab}`);
    // console.log({ tabsMenuElement, activeTabAttribute, activeTab, activeTabElement });

    console.log('hydrate-tabs-menu getActiveTab', { activeTabElement });

    return activeTabElement;
  }

  return null;
};

/**
 * Hydrate Live score main menu and Tabs
 */
export const hydrateMenuTabs = (): void => {
  const menu: Element | null = document.querySelector(`.${CSS_PREFIX}${TABS_MENU_CLASSNAME}`);

  console.log('hydrate-tabs-menu hydrateMenuTabs', { menu });

  if (menu) {
    const menuItems: HTMLCollection = menu.children;

    console.log('hydrate-tabs-menu hydrateMenuTabs', { menuItems });

    Array.from(menuItems).forEach((tab: Element) => {
      tabAddClickListener(menu, tab);
    });

    // Show DEFAULT/SELECTED TAB content
    const activeTab: HTMLElement | null = getActiveTab('CONTENT');
    console.log('hydrate-tabs-menu hydrateMenuTabs', { activeTab });
    activeTab && (activeTab.style.display = 'block');

    updateTabsPosition();
  }
};

export const tabAddClickListener = (menu: Element, tab: Element): void => {
  const dataUrl: string | null = tab.getAttribute('data-url') || '';
  const dataTabUrl: string | null = tab.getAttribute('data-tab-url');
  const dataTracking: string | null = tab.getAttribute('data-tracking') || '';
  const tabText: string = tab.getElementsByTagName('span')[0]?.innerHTML.toLocaleLowerCase(); // TEXT in the tab
  const id: string = tab.getAttribute('id')!.replace(`${CSS_PREFIX}${TAB_ITEM_CLASS_PREFIX}`, '') || '';

  console.log('hydrate-tabs-menu tabAddClickListener', { menu, tab, dataUrl, dataTabUrl, dataTracking, tabText, id });

  /** custom click event to dispatch */
  const clickEvent = new CustomEvent(LIVE_SCORE_MENU_ITEM_CLICKED_EVENT, {
    bubbles: true,
    detail: { dataTabUrl, dataUrl, dataTracking, tabText, id },
  });

  tab.addEventListener('click', (e) => {
    const tabContent: HTMLElement | null = document.querySelector(`#${CSS_PREFIX}${TAB_SWITCH_CONTENT_ID}${id}`);
    const target = e.target as HTMLLIElement;
    target.dispatchEvent(clickEvent);
    console.log('hydrate-tabs-menu tabAddClickListener', { tabContent });

    if (tabContent?.children.length && id) {
      switchTab(menu, id, dataUrl);
      (window as any)._satellite?.track('cambio_tab', { tab_label: target.textContent?.trim().toLowerCase() });
      localStorage.setItem('intcmp', dataTracking);
    }
  });
};

/**
 * Switch tab on Menu
 * @param menu Menu element for tab focus
 * @param id id of the elements
 */
const switchTab = (menu: Element | null, id: string, dataUrl = '') => {
  menu && menu.setAttribute('data-state', `${ACTIVE_TAB_CLASS_PREFIX}${id}`);
  console.log('hydrate-tabs-menu switchTab', { menu });

  // ISS-6691 Handle content show/hide
  document.querySelectorAll(`.${CSS_PREFIX}${TAB_SWITCH_CONTENT}`).forEach((item: HTMLElement, index: number) => {
    String(index) === id ? (item.style.display = 'block') : (item.style.display = 'none');
  });

  urlUpdate(dataUrl, history);

  updateTabsPosition();
};

// ISS-5096
export const clickFromHash = () => {
  // Get #HASH of CURRENT URL
  const hash: string = getHash();

  if (hash !== '') {
    // CLICK on TAB with DATA-URL=#HASH
    const tab: HTMLElement | null = document.querySelector(`.ftbl__tab-item[data-url="${hash}`);
    if (tab) {
      tab.click();
    } else {
      console.warn('Tab with DATA-URL', hash, 'not found'); // eslint-disable-line no-console
    }
  }
};

export const getHash = (): string => {
  return window!.location!.hash ?? '';
};
